import type { ClimbSessionOut } from "@/types/api";
import client from "./client";

export async function listSessions(params?: {
  year?: number;
  since?: string; // ISO date "YYYY-MM-DD"
  until?: string;
}): Promise<ClimbSessionOut[]> {
  const res = await client.get<ClimbSessionOut[]>("/sessions", {
    params: params ?? undefined,
  });
  return res.data;
}

export async function createSession(data: {
  session_date: string;
  gym_name?: string;
  session_type?: "gym" | "outdoor";
  area?: string;
  crag_name?: string;
  notes?: string;
}): Promise<ClimbSessionOut> {
  const res = await client.post<ClimbSessionOut>("/sessions", data);
  return res.data;
}

export async function getSession(id: number): Promise<ClimbSessionOut> {
  const res = await client.get<ClimbSessionOut>(`/sessions/${id}`);
  return res.data;
}

export async function updateSession(
  id: number,
  data: { session_date?: string; gym_name?: string | null; session_type?: "gym" | "outdoor" | null; area?: string | null; crag_name?: string | null; notes?: string | null }
): Promise<ClimbSessionOut> {
  const res = await client.patch<ClimbSessionOut>(`/sessions/${id}`, data);
  return res.data;
}

export async function deleteSession(id: number): Promise<void> {
  await client.delete(`/sessions/${id}`);
}
